export const SEARCHER_TRANSLATION = {
  en: 'Searcher',
  fr: 'Chercheur',
  de: 'Sucher',
  es: 'Buscador',
  pt: 'Buscador',
  it: 'Cercatore',
}

export const CATALOG_TRANSLATION = {
  en: 'Catalog',
  fr: 'Catalogue',
  de: 'Katalog',
  es: 'Catálogo',
  pt: 'Catálogo',
  it: 'Catalogo',
}

export const BRAND_TRANSLATION = {
  en: 'Brand',
  fr: 'Marque',
  de: 'Marke',
  es: 'Marca',
  pt: 'Marca',
  it: 'Marca',
}

export const PRODUCT_TRANSLATION = {
  en: 'Product',
  fr: 'Produit',
  de: 'Produkt',
  es: 'Producto',
  pt: 'Produto',
  it: 'Prodotto',
}

export const ADD_TO_CART_TRANSLATION = {
  en: 'Add to cart',
  fr: 'Ajouter au panier',
  de: 'In den Warenkorb',
  es: 'Añadir al carrito',
  pt: 'Adicionar ao carrinho',
  it: 'Aggiungi al carrello',
}

export const REMOVE_FROM_CART_TRANSLATION = {
  en: 'Remove from cart',
  fr: 'Retirer du panier',
  de: 'Vom Warenkorb entfernen',
  es: 'Quitar del carrito',
  pt: 'Remover do carrinho',
  it: 'Rimuovi dal carrello',
}

export const DELETE_FROM_CART_TRANSLATION = {
  en: 'Delete from cart',
  fr: 'Supprimer du panier',
  de: 'Aus dem Warenkorb entfernen',
  es: 'Eliminar del carrito',
  pt: 'Eliminar do carrinho',
  it: 'Elimina dal carrello',
}


